export class ModalError extends Error {
  readonly name = 'ModalError';
  constructor(message: string, options?: { cause: Error }) {
    super(message, options);
    // https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
    Object.setPrototypeOf(this, ModalError.prototype);
  }
  static stackTraceLimit = 1;
}

export const CANCELLED_BY_USER = new ModalError('Cancelled by user');

export const isModalError = (t: unknown): t is ModalError => typeof t === 'object' && t !== null && 'name' in t && t.name === 'ModalError';

export const isCancelled = (t: unknown): t is ModalError => isModalError(t) && t.message === 'Cancelled by user';
